<template>
  <div class="HomePage">
    <v-carousel
      cycle
      :show-arrows="false"
      hide-delimiter-background
      delimiter-icon="fa-minus"
      height="100%"
      class="banner mt-4"
    >
      <v-skeleton-loader v-if="!banners.length" width="100%" type="image"></v-skeleton-loader>
      <v-carousel-item 
        v-for="banner in banners.slice(0, banners.length / 2 + 1)"
        :src="$HOST_URL + banner.path"
        :aspect-ratio="4"
        class="pointer"
        @click="$root.$emit('simpleDialog', [banner.text])"
      ></v-carousel-item>
    </v-carousel>

    <v-carousel
      cycle
      :show-arrows="false"
      hide-delimiter-background
      delimiter-icon="fa-minus"
      height="100%"
      class="banner"
      v-if="banners.length > 2"
    >
      <v-skeleton-loader dark v-if="!banners.length" width="100%" type="image"></v-skeleton-loader>
      <v-carousel-item 
        v-for="banner in banners.slice(banners.length / 2 + 1)"
        :src="$HOST_URL + banner.path"
        :aspect-ratio="4"
        class="pointer"
        @click="$root.$emit('simpleDialog', [banner.text])"
      ></v-carousel-item>
    </v-carousel>

    <Gallery title="熱門推薦" type="seller" :items="newcomers"></Gallery>

    <div class="carousel">
      <div class="tablet-only desktop-only hidden">
        <button class="control-btn left" @click="carouselMove('left')">
          <v-icon color="white">fa-chevron-left</v-icon>
        </button>
      </div>
      <div class="tablet-only desktop-only hidden">
        <button class="control-btn right" @click="carouselMove('right')">
          <v-icon color="white">fa-chevron-right</v-icon>
        </button>
      </div>
      <div class="carousel-container">
        <v-row 
          class="carousel-itemList" 
          :style="!carouselItems.length ? `transform: translateX(calc((100vw - ${carouselItemWidth * 3}px) * 0.5))` : ''"
          v-touch="{
            left: () => carouselMove('right'),
            right: () => carouselMove('left'),
          }"
        >
          <div class="carousel-item" v-for="i in 3" v-if="!carouselItems.length">
            <v-skeleton-loader dark width="100%" type="image, paragraph"></v-skeleton-loader>
          </div>
          <router-link 
            v-for="(item, i) in carouselItems" 
            :key="i"
            class="carousel-item" 
            :style="focusCarouselItem != i ? 'opacity: .5' : ''"
            :to="`/product/${item.latest_product.id}`"
          >
            <div class="video-block">
              <span class="free" v-if="item.latest_product.price === 0">Free</span>
              <span class="unlocked" v-if="purchaseID.includes(item.latest_product.id)">已解鎖</span>
              <video-player 
                v-once
                :ref="`video${i}`"
                v-touch-event="() => $router.push(`/product/${item.latest_product.id}`)"
                :playsinline="true" 
                @canplay="onPlayerCanplay($event, i)"
                :options="$func.videoOption({
                  src: (focusCarouselItem == i) ? $HOST_URL + item.latest_product.video_info[0].uuid_path : null,
                  autoplay: $videojs.browser.IS_SAFARI ? true : false,
                  muted: true,
                  loop: true,
                  controls: false,
                  poster: $HOST_URL + item.latest_product.video_info[0].preview_path
                })"></video-player>
            </div>
            <div class="description">
              <v-avatar size="50" @click.prevent="$router.push(`/seller/${item.id}`)">
                <v-img :src="$HOST_URL + item.usericon"/>
              </v-avatar>
              <h3 class="text-ellipsis my-2" :title="item.latest_product.title">{{ item.latest_product.title }}</h3>
              <div class="d-flex align-center justify-center review">
                <div class="text-center">
                  <v-icon>fa-thumbs-up</v-icon><br>
                  <span>{{ mul(item.latest_product.praise_rate, 100) }}%</span>
                </div>
                <div class="price-block">
                  <div class="peach mr-1"></div>
                  {{ item.latest_product.price }}
                </div>
                <div class="text-center">
                  <v-icon>fa-unlock</v-icon><br>
                  <span>{{ item.latest_product.unlocks }}</span>
                </div>
              </div>
            </div>
          </router-link>
        </v-row>
      </div>
    </div>

    <v-system-bar height="35">
      <v-icon class="mr-2" color="red">fa-bullhorn</v-icon>
      <div class="announcement-container">
        <div id="announcement" style="left: 100%">
          <template v-for="announcement in announcements">
            <span style="width: 500px"></span>
            <span>{{ announcement }}</span>
          </template>
        </div>
      </div>
    </v-system-bar>

    <Gallery title="熱門榜" to="/ranking" :items="hots" v-if="hots.length"></Gallery>

    <Gallery title="新人榜" type="seller" to="/category/newcomer" :items="newcomers" v-if="newcomers.length"></Gallery>

    <Gallery title="熱門動態" type="story" to="/category/story" :items="storys" v-if="storys.length"></Gallery>

    <Gallery title="長片" to="/category/video" :items="videos" v-if="videos.length"></Gallery>

    <Gallery title="寫真" type="photo" to="/category/photo" :items="photos" v-if="photos.length"></Gallery>

    <Gallery title="原味衣物" to="/category/clothes" :items="clothes" v-if="clothes.length"></Gallery>

    <Gallery title="在線主播" type="onlineSeller" to="/category/seller/online" :items="newcomers" v-if="newcomers.length"></Gallery>

    <BuyPeachSuccessful ref="buyPeachSuccessful"></BuyPeachSuccessful>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Header from '@/components/Header'
import BuyPeachSuccessful from '@/components/BuyPeachSuccessful'
import Gallery from '@/components/Gallery'
export default {
  components: { Header, BuyPeachSuccessful, Gallery },
  data() {
    return {
      banners: [],
      hots: [],
      newcomers: [],
      storys: [],
      videos: [],
      photos: [],
      clothes: [],
      carouselItemNum: 0,
      moving: false,
      timer: '',
      windowWidth: window.innerWidth,
      basicTransform: '',
      carouselItems: [],
      focusCarouselItem: null,
      products: [],
      announcements: []
    }
  },
  created() {
    if(this.$route.query.p) {
      this.$refs.buyPeachSuccessful.setValue(this.$route.query.p)
    }
    if(this.$route.query.rtnCode && this.$route.query.rtnCode != '1') {
        if(this.$route.query.rtnCode == '10800001') {
            this.$root.$emit('errorDialog', ['信用卡交易失敗，請稍後再試一次。'])
        }
    }
    this.getBanners()
    this.getHots()
    this.getNewcomers()
    this.getStorys()
    this.getVideos()
    this.getPhotos()
    this.getClothes()
  },
  mounted() {
    this.getCarouselItems().then(() => {
      this.initialCarousel()
      this.resetCarouselAutoMove()
    })
    this.getAnnouncements().then(() => {
      this.announcementAnimation()
    })
    // this.carouselMove_mobile()
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
      this.initialCarousel()
    })
  },
  watch: {
    focusCarouselItem(newValue, oldValue) {
      if (newValue !== null && this.carouselItems[newValue] && this.carouselItems[newValue].latest_product) {
        this.$func.stopPlayVideo(this.$refs, oldValue)
        this.$func.startPlayVideo(this.$refs, newValue, this.$HOST_URL + this.carouselItems[newValue].latest_product.video_info[0].uuid_path)
      }
    }
  },
  computed: {
    ...mapGetters('user', ['purchaseID']),
    carouselItemList() {
      return document.getElementsByClassName('carousel-itemList')[0]
    },
    carouselItemWidth() {
      return (this.windowWidth <= 767) ? (320 + 4) : (700 + 4)    //ItemWidth + margin
    },
  },
  methods: {
    initialCarousel() {
      this.carouselItemList.style.width = this.carouselItemWidth * this.carouselItemNum + 'px'
      if(this.carouselItemNum % 2 == 1) {
        this.carouselItemList.style.transform = `translateX(calc((100vw - ${this.carouselItemList.style.width}) * 0.5))`
      }
      else {
        this.carouselItemList.style.transform = `translateX(calc((100vw - ${this.carouselItemList.style.width}) * 0.5 + ${this.carouselItemWidth / 2}px))`
      }
      this.basicTransform = this.carouselItemList.style.transform
    },
    carouselMove(direction) {
      if(this.moving || this.carouselItemNum == 1) {
        return
      }
      this.resetCarouselAutoMove()
      this.moving = true
      this.carouselItemList.style.transition = 'all .5s ease'
      if(direction == 'right') {
        let childNode = this.carouselItemList.children[0]
        this.carouselItemList.style.transform = this.basicTransform.slice(0, -2) + ` - ${this.carouselItemWidth + 3}px))`
        setTimeout(() => {  //wait for css animation
          this.carouselItemList.style.transition = ''
          childNode.parentNode.appendChild(childNode)
          this.carouselItemList.style.transform = this.basicTransform
          this.focusCarouselItem = this.getItemSibling(this.focusCarouselItem, 'right')
          this.moving = false
        }, 600)
      }
      else if(direction == 'left') {
        let childNode = [...this.carouselItemList.children].pop()
        this.carouselItemList.style.transform = this.basicTransform.slice(0, -2) + ` + ${this.carouselItemWidth + 3}px))`
        setTimeout(() => {  //wait for css animation
          this.carouselItemList.style.transition = ''
          childNode.parentNode.insertBefore(childNode, childNode.parentNode.firstChild)
          this.carouselItemList.style.transform = this.basicTransform
          this.focusCarouselItem = this.getItemSibling(this.focusCarouselItem, 'left')
          this.moving = false
        }, 600)
      }
    },
    resetCarouselAutoMove() {
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.carouselMove('right')
      }, 15000)
    },
    // carouselMove_mobile() {
    //   let self = this
    //   this.carouselItemList.addEventListener('touchstart', e => {
    //     if(this.moving || this.carouselItemNum == 1) {
    //       return
    //     }
    //     clearInterval(this.timer)
    //     let prevX = e.touches[0].pageX
    //     let distance = 0
    //     function move(e) {
    //       let curX = e.touches[0].pageX
    //       distance = prevX - curX
    //       // self.carouselItemList.style.transform = self.basicTransform.slice(0, -2) + ` - ${distance}px))`
    //     }
    //     this.carouselItemList.addEventListener('touchmove', move)
    //     this.carouselItemList.addEventListener('touchend', e => {
    //       this.carouselItemList.removeEventListener('touchmove', move)
    //       let basis = 30
    //       if(Math.abs(distance) > basis) {
    //         if(distance > 0) {
    //           this.carouselMove('right')
    //         }
    //         else if(distance < 0) {
    //           this.carouselMove('left')
    //         }
    //       }
    //     }, { once: true })
    //   })
    // },
    getItemSibling(i, direction) {
      if(direction == 'left') {
        return (i - 1 + this.carouselItemNum) % this.carouselItemNum
      }
      else {
        return (i + 1) % this.carouselItemNum
      }
    },
    onPlayerCanplay(player, i) {
      this.focusCarouselItem == i ? player.play() : ''
    },
    getBanners() {
      this.axios('/banner').then(response => {
        this.banners = response.data
      })
    },
    getCarouselItems() {
      return this.axios('/product/rank/video?type=month&page=1&size=50').then(response => {
        let items = response.data.data.filter(data => data.latest_video_product).map(data => {
          data.latest_product = data.latest_video_product
          return data
        })
        this.carouselItemNum = items.length
        let middle = (this.carouselItemNum % 2 == 0) ? this.carouselItemNum / 2 + 1 : this.carouselItemNum / 2
        this.carouselItems = [...items.slice(middle), ...items.slice(0, middle)]
        this.focusCarouselItem = Math.floor(this.carouselItemNum - middle)
      })
    },
    getHots() {
      this.axios('/product/rank/all?type=month&page=1&size=50').then(response => {
        this.hots = response.data.data.filter(data => data.latest_all_product).map(data => {
          data.latest_product = data.latest_all_product
          return data
        })
      })
    },
    getNewcomers() {
      this.axios('/product/rank/newcomer?type=month&page=1&size=50').then(response => {
        this.newcomers = response.data.data
      })
    },
    getStorys() {
      this.axios('/product/rank/story?type=month&page=1&size=50').then(response => {
        this.storys = response.data.data.filter(data => data.latest_story_product).map(data => {
          data.latest_product = data.latest_story_product
          return data
        })
      })
    },
    getVideos() {
      this.axios('/product/rank/video?type=month&page=1&size=50').then(response => {
        this.videos = response.data.data.filter(data => data.latest_video_product).map(data => {
          data.latest_product = data.latest_video_product
          return data
        })
      })
    },
    getPhotos() {
      this.axios('/product/rank/photo?type=month&page=1&size=50').then(response => {
        this.photos = response.data.data.filter(data => data.latest_photo_product).map(data => {
          data.latest_product = data.latest_photo_product
          return data
        })
      })
    },
    getClothes() {
      this.axios('/product/rank/clothes?type=month&page=1&size=50').then(response => {
        this.clothes = response.data.data.filter(data => data.latest_clothes_product).map(data => {
          data.latest_product = data.latest_clothes_product
          return data
        })
      })
    },
    getAnnouncements() {
      return this.axios.get('/announcement').then(response => {
        this.announcements = response.data.data
      })
    },
    announcementAnimation() {
      let announcement = document.getElementById('announcement')
      setInterval(() => {
        if(!announcement) {
          return
        }
        let leftVal = parseInt(announcement.style.left, 10)
        if(leftVal < 0 && Math.abs(leftVal) > announcement.clientWidth) {
          announcement.style.left = window.innerWidth + 'px'
          return
        }
        announcement.style.left = (leftVal - 1) + 'px'
      }, 10)
    },
  }
}
</script>

<style lang="scss" scoped>
.HomePage {
  .banner {
    max-width: 500px;
    overflow: hidden;
    margin: 20px auto;
    .v-skeleton-loader {
      height: 125px;
      border-radius: 10px;
    }
    .v-image {
      border-radius: 10px;
    }
    .v-carousel__controls {
      height: 28px;
      .v-carousel__controls__item i {
        color: white !important;
        opacity: 1;
        font-size: 12px !important;
      }
    }
  }
  .carousel {
    position: relative;
    margin-bottom: 16px;
    .control-btn {
      position: absolute;
      width: 70px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1;
      &:focus {
        outline: none;
      }
    }
    .left {
      left: 0;
      top: 0;
      background: linear-gradient(to left, rgba(0, 0, 0, 0), rgba(0, 0, 0, .5));
      &:hover {
        background: linear-gradient(to left, rgba(0, 0, 0, 0), rgba(0, 0, 0, .8));
      }
    }
    .right {
      right: 0;
      top: 0;
      background: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, .5));
      &:hover {
        background: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, .8));
      }
    }
    .carousel-container {
      .carousel-itemList {
        display: flex;
        flex-wrap: nowrap;
        box-sizing: border-box;
        .carousel-item {
          position: relative;
          margin: 0 4px;
          min-width: 700px;
          background-color: $grey-3;
          user-select: none;
          @include tablet {
            position: relative;
            min-width: 320px;
            font-size: 14px;
          }
          @include mobile {
            position: relative;
            min-width: 320px;
            font-size: 12px;
          }
          .soldOut {
            width: 80px;
            height: 80px;
            font-size: 20px;
            @include tablet {
              width: 50px;
              height: 50px;
              font-size: 12px;
            }
          }
          .video-block {
            overflow: hidden;
            width: 100%;
            height: 400px;
            @include tablet {
              height: 190px;
            }
            @include mobile {
              height: 190px;
            }
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              object-position: center;
              background-size: cover;
              background-position: center;
            }
          }
          .description {
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;
            padding: 30px 20px 15px 20px;
            background-color: $grey-3;
            @include tablet {
              position: unset;
              padding: 10px;
            }
            @include mobile {
              position: unset;
              padding: 10px;
            }
            .v-avatar {
              position: absolute;
              top: 0;
              border: 1px white solid;
              transform: translateY(-25px);
              @include tablet {
                position: absolute;
                top: 32px;
                left: 5px;
              }
              @include mobile {
                position: absolute;
                top: 32px;
                left: 5px;
              }
            }
            .price-block {
              display: flex;
              align-items: center;
              padding: 4px 24px;
              margin: 4px 64px 0;
              color: pink;
              border: 1px pink solid;
              border-radius: 20px;
              font-size: 14px;
              @include tablet {
                margin: 4px 40px 0;
              }
              @include mobile {
                margin: 4px 40px 0;
              }
            }
            .review {
              i {
                font-size: 24px !important;
              }
              span {
                margin: auto;
              }
            }
          }
        }
        .v-skeleton-loader__image {
          width: 100%;
          height: 400px;
          @include tablet {
            height: 190px;
          }
          @include mobile {
            height: 190px;
          }
        }
        .v-skeleton-loader__paragraph {
          height: 136px;
          padding: 40px;
          @include tablet {
            height: 105px;
            padding: 25px;
          }
          @include mobile {
            height: 105px;
          }
        }
      }
    }
  }
  .announcement-container {
    position: relative;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    div {
      position: absolute;
      width: max-content;
      display: flex;
      align-items: center;
      height: 35px;
      span {
        height: 20px;
        float: left;
        white-space: nowrap;
      }
    }
  }
}
</style>